import React, { useState, useRef, useCallback } from "react";
import classNames from "classnames";
import { useServices } from "@/services-context";
import styles from "./MenuSm.module.scss";
import DrawerPanel from "@/elements-react/drawer-panel";
import MainScreen from "./MainScreen";
import SubcategoriesScreen from "./SubcategoriesScreen";
import { LayoutSmContainer } from "@/elements-react/menu/LayoutSm.tsx";

type Step = "main" | "subcategory" | "account" | "garage";

type MenuSmProps = {
  onClose?: () => void;
};

export const MenuSm: React.FC<MenuSmProps> = ({ onClose }) => {
  const [step, setStep] = useState<Step>("main");
  const [categoryId, setCategoryId] = useState<string | null>(null);
  const panelRef = useRef<any>(null);

  const services = useServices();
  const categories = services.categories;

  const handleCategoryClick = useCallback((key: string) => {
    setStep((prev) => (prev === "main" ? "subcategory" : "main"));
  }, []);

  const toRootCategory = useCallback((categoryId: string) => {
    setStep("subcategory");
    setCategoryId(categoryId);
  }, []);

  const toSubcategory = useCallback((key: string) => {
    onClose?.();
  }, []);

  const onBackClick = useCallback(() => {
    setStep("main");
  }, []);

  const renderSubcategoryScreen = () => {
    if (!categoryId) return null;
    const items = categories.getChilds(categoryId);
    const parentCategory = categories.getItem(categoryId);
    return <SubcategoriesScreen items={items} parentCategory={parentCategory} onToCategory={toSubcategory} onBack={onBackClick} />;
  };

  const renderMainScreen = () => {
    const items = categories.findTopLevelCategories().map((item: any) => categories.getItem(item.id));
    return <MainScreen items={items} onToCategory={toRootCategory} />;
  };

  return (
    <div className={classNames(styles.root)}>
      <DrawerPanel ref={panelRef} state={"visible"} onClose={() => onClose?.()}>
        <LayoutSmContainer>
          {step === "main" && renderMainScreen()}
          {step === "subcategory" && renderSubcategoryScreen()}
        </LayoutSmContainer>
      </DrawerPanel>
    </div>
  );
};

export default MenuSm;
